import Swiper from 'swiper';
import { Navigation, Pagination } from 'swiper/modules';

class HelsanaSwiper {
  constructor() {
		const swiper = new Swiper('.swiper', {
			// configure Swiper to use modules
			modules: [Navigation, Pagination],
			pagination: {
				el: '.swiper-pagination',
			},

			// Navigation arrows
			navigation: {
				nextEl: '.swiper-button-next',
				prevEl: '.swiper-button-prev',
			}

		});
  }

}

export default HelsanaSwiper;
